module.exports = __webpack_public_path__ + "img/top_m.bfbf144a.png";